import { readEmbedUrl } from "../utils";
import { restJson } from "./httpClient";
import type { ListMessagesResponse } from "../types";

const MESSAGES_BASE_PATH = "/ai/insights/messages";
const CONVERSATIONS_BASE_PATH = "/ai/insights/conversations";

export type ListedMessage = {
  id: string;
  role: string;
  content: string;
  createdAt: string;
  positiveFeedback: boolean | null;
  summary: string | null;
};

export type ListMessagesResult = {
  messages: ListedMessage[];
};

export async function listMessages(conversationId: string): Promise<ListMessagesResult> {
  const response = await restJson<ListMessagesResponse>(
    `${CONVERSATIONS_BASE_PATH}/${encodeURIComponent(conversationId)}/messages`,
  );
  return {
    messages: response.messages.map((message) => ({
      id: message.id,
      role: message.role,
      content: readEmbedUrl(message.metadata) ?? message.content,
      createdAt: message.created_at,
      positiveFeedback: message.positive_feedback,
      summary: message.summary,
    })),
  };
}

export async function updateMessageFeedback(
  messageId: string,
  positiveFeedback: boolean | null,
): Promise<void> {
  await restJson<unknown>(`${MESSAGES_BASE_PATH}/${encodeURIComponent(messageId)}/feedback`, {
    method: "PUT",
    body: { positive_feedback: positiveFeedback },
  });
}
